// Agent actions
export const FETCH_AGENTS_REQUEST = "FETCH_AGENTS_REQUEST";
export const FETCH_AGENTS_SUCCESS = "FETCH_AGENTS_SUCCESS";
export const FETCH_AGENTS_FAILURE = "FETCH_AGENTS_FAILURE";

// Device actions
export const FETCH_DEVICES_REQUEST = "FETCH_DEVICES_REQUEST";
export const FETCH_DEVICES_SUCCESS = "FETCH_DEVICES_SUCCESS";
export const FETCH_DEVICES_FAILURE = "FETCH_DEVICES_FAILURE";

// Topology actions
export const FETCH_TOPOLOGY_REQUEST = "FETCH_TOPOLOGY_REQUEST";
export const FETCH_TOPOLOGY_SUCCESS = "FETCH_TOPOLOGY_SUCCESS";
export const FETCH_TOPOLOGY_FAILURE = "FETCH_TOPOLOGY_FAILURE";

// Network info actions
export const FETCH_NETWORK_INFO_REQUEST = "FETCH_NETWORK_INFO_REQUEST";
export const FETCH_NETWORK_INFO_SUCCESS = "FETCH_NETWORK_INFO_SUCCESS";
export const FETCH_NETWORK_INFO_FAILURE = "FETCH_NETWORK_INFO_FAILURE";

// Speed test actions
export const FETCH_SPEED_TEST_REQUEST = "FETCH_SPEED_TEST_REQUEST";
export const FETCH_SPEED_TEST_SUCCESS = "FETCH_SPEED_TEST_SUCCESS";
export const FETCH_SPEED_TEST_FAILURE = "FETCH_SPEED_TEST_FAILURE";

// Downtime actions
export const FETCH_DOWNTIME_REQUEST = "FETCH_DOWNTIME_REQUEST";
export const FETCH_DOWNTIME_SUCCESS = "FETCH_DOWNTIME_SUCCESS";
export const FETCH_DOWNTIME_FAILURE = "FETCH_DOWNTIME_FAILURE";

// Customer actions
export const FETCH_CUSTOMERS_REQUEST = "FETCH_CUSTOMERS_REQUEST";
export const FETCH_CUSTOMERS_SUCCESS = "FETCH_CUSTOMERS_SUCCESS";
export const FETCH_CUSTOMERS_FAILURE = "FETCH_CUSTOMERS_FAILURE";
export const SET_SELECTED_CUSTOMER = "SET_SELECTED_CUSTOMER";

// UI state actions
export const SET_SELECTED_AGENT = "SET_SELECTED_AGENT";
export const SET_DEVICE_FILTERS = "SET_DEVICE_FILTERS";
export const SET_DEVICE_PAGINATION = "SET_DEVICE_PAGINATION";
